module.exports = __webpack_public_path__ + "static/bill_small_shadow-fb9ae650979834e2cb18b35d5265ed52.png";